import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Layout from "../Layout/Layout";
import { RootState } from "../../redux/rootReducers";
import api from "../../api";

const SSO_TOKEN_URL = process.env.REACT_APP_SSO_TOKEN_URL ?? "";
const SSO_IFRAME_BASE = process.env.REACT_APP_SSO_IFRAME_BASE ?? "";

const Tickets: React.FC = () => {
  const authApi = useSelector((state: RootState) => state.authReducer);
  const location = useLocation();
  const [ssoToken, setSsoToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const layoutType: "admin" | "partner" | "merchant" =
    (location.state as any)?.layoutType ??
    (authApi.role === "admin"
      ? "admin"
      : authApi.role === "partner"
        ? "partner"
        : "merchant");

  useEffect(() => {
    const email = authApi.role === "admin" ? authApi.email : authApi.username;

    console.log(authApi);
    if (!email) {
      setError("User email not available.");
      setLoading(false);
      return;
    }

    axios
      .post(
        SSO_TOKEN_URL,
        { email },
        {
          headers: {
            Authorization: `Bearer ${authApi.token}`,
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        },
      )
      .then((res) => {
        const token = res.data?.data?.attributes.sso_token;
        if (token) {
          setSsoToken(token);
        } else {
          setError("SSO token not found in response.");
        }
      })
      .catch((err) => {
        console.error(
          "SSO error:",
          err?.response?.status,
          err?.response?.data,
          err?.message,
        );
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            "Failed to obtain SSO token.",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [authApi.username]);
  return (
    <Layout type={layoutType}>
      <div
        className="content-side"
        style={{ marginTop: "58px", height: "calc(100vh - 58px)", padding: 0 }}
      >
        {loading && (
          <div style={{ padding: "24px", textAlign: "center" }}>Loading...</div>
        )}
        {error && <div style={{ padding: "24px", color: "red" }}>{error}</div>}
        {ssoToken && (
          <iframe
            src={`${SSO_IFRAME_BASE}?token=${ssoToken}`}
            width="100%"
            height="100%"
            style={{ border: "none", display: "block" }}
            title="Tickets"
          />
        )}
      </div>
    </Layout>
  );
};

export default Tickets;
